import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoadingService } from '@shared/services.loading';
import { Observable } from 'rxjs';

interface LoadingConfig {
  bgTransparent?: boolean;
  bgWhite?: boolean;
}

@Component({
  selector: 'wec-loading',
  standalone: true,
  imports: [NgClass, AsyncPipe],
  templateUrl: './wec-loading.component.html',
  styleUrl: './wec-loading.component.scss'
})
export class WecLoadingComponent {
  isLoading = false;
  isDisabled = false; 
  config?: LoadingConfig | null;
  disabledLoaders = [
    '/store/'
  ];

  queue!: Observable<number>;

  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.queue = this.loadingService.queue;
    this.handleRouterNavigationState();
    this.handleSetConfigLoading();
  }

  handleRouterNavigationState() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (this.disabledLoaders.some((s) => val.urlAfterRedirects.includes(s))) {
          this.isDisabled = true;
        }
        else {
          this.isDisabled = false;
        }
      }
    });
  }

  handleSetConfigLoading() {
    this.loadingService.config
      .subscribe(config => {
        this.config = config;
      });

    this.loadingService.status.subscribe((status: boolean) => this.isLoading = status);
  }

}
